import { Fade } from 'react-awesome-reveal';
import SectionTitle from 'modules/website/shared/components/SectionTitle';
import useIsPhone from 'modules/website/hooks/useIsPhone';
import PolitiquesSectorialsMobile from 'modules/website/pages/Home/components/PolitiquesSectorialsMobile';
import SectorialSelector from './SectorialSelector';
import './PolitiquesSectorials.scss';

function PolitiquesSectorials() {
  const isPhone = useIsPhone();
  return (
    <div className="home__politiquessectorials__container">
      <div className="main__content__padding">
        <Fade triggerOnce delay={50} cascade>
          <div className="politiquessectorials--title">
            <SectionTitle title="POLÍTIQUES SECTORIALS" />
          </div>

          <div className="flex-center">
            <p style={{ maxWidth: 800 }}>
              Des de Junts presentem diferents polítiques sectorials per aportar solucions als temes
              que preocupen, per desenvolupar els àmbits temàtics i per potenciar el coneixement i
              l’expertesa; debatre, posicionar-se i donar solucions als temes que preocupen, en tota
              l’amplitud i complexitat de l’organització social i econòmica del país.
            </p>
          </div>
          <div className="politiquessectorials__selector">
            {isPhone ? <PolitiquesSectorialsMobile /> : <SectorialSelector />}
          </div>
        </Fade>
      </div>
    </div>
  );
}

export default PolitiquesSectorials;
